import styled from 'styled-components'

export const LabelFile = styled.label`
display: flex;
align-items: center;
font-size: .813rem;
padding:.325rem .75rem;
background:#${props => props.theme};
border-radius: 0.25rem;
color: var(--c1);
margin-top: .5rem;
gap: .25rem;

&:hover{
    filter: brightness(1.05);
    box-shadow: var(--SombraBtns);
}
cursor: pointer;
    svg{
        margin: 0rem 0.3rem 0rem .3rem;
    }
`

export const GuideText = styled.div`
font-family: 'Roboto','sans-serif';
font-style: normal;
font-weight: 700;
font-size: .875rem;
line-height: 1rem;
`

export const FileBox = styled.div<{ isOpcional: boolean }>`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: var(--c2);
${props => props.isOpcional ? 'border: 1px solid var(--Orange);' : 'border: 1px solid var(--c5);'}
border-radius: .25rem;
padding: 1rem;
text-align: center;
height: 16rem;
width: 23rem;
font-weight: 500;
position: relative;
input[type=file]{
    display: none;
}

strong{
    font-weight: 700;
}
`
